var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.47 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef6e2a;}.cls-2{fill:#545860;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.61,43l0-7.67a32.42,32.42,0,0,0-11.11-2.81A49,49,0,0,0,4.91,35,47,47,0,0,1,0,36.28H0v2.51c2.51-.21,5.12-.33,7.8-.33C18.38,38.46,28,40.15,34.61,43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.27,0V18c0,.48,0,1,0,1.52s0,1.07,0,1.6,0,1,.07,1.5h-.11c-.52-.77-1.05-1.5-1.58-2.21L23,18.21,8.42,0H0V33.91H0a47,47,0,0,0,4.91-1.28c1.08-.32,2.21-.66,3.45-1V16.47c0-.48,0-1,0-1.44s0-.93,0-1.36-.06-.79-.1-1.1h.11L10,14.86l1.69,2.2L22.11,30.13l1.41.06A32.64,32.64,0,0,1,34.63,33V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.31,42.14A82.81,82.81,0,0,0,5.76,40.48,48.6,48.6,0,0,0,0,40.77V55.23a162.25,162.25,0,0,1,31.38-3.61h.21c1,0,2.05,0,3,.11V45.55a100,100,0,0,0-12.32-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.38,53.9A163.15,163.15,0,0,0,0,57.5V60H34.63V54c-1-.07-2.06-.11-3-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.71,59.9a9.58,9.58,0,0,1-6.9-2.37,10.07,10.07,0,0,1-3-7.59,11.53,11.53,0,0,1,1.67-6.37,9.82,9.82,0,0,1,8.36-4.44,10.19,10.19,0,0,1,5.67,1.59l-2,2.71a6.81,6.81,0,0,0-3.62-1.08,5.25,5.25,0,0,0-4.25,2.15,8.29,8.29,0,0,0-1.15,4.85c0,2.85.29,4.33,1.34,5.55A5.14,5.14,0,0,0,52,56.72,6.91,6.91,0,0,0,56,55.53l2,2.49a9.92,9.92,0,0,1-6.22,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.84,42.35c-4.18,0-4.78,3.93-4.78,7.18,0,3.63.49,7.34,5,7.34,4.25,0,4.74-3.93,4.74-7.22,0-3.48-.52-7.3-4.92-7.3m.29,17.52c-6.22,0-9.73-4.19-9.73-10.26C64.4,43.13,68,39.24,74,39.24c6.37,0,9.58,4.26,9.58,10.26s-2.87,10.37-9.4,10.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.94 59.57 91.3 59.57 91.3 39.54 95.52 39.54 95.52 56.16 103.72 56.16 102.94 59.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.37 59.57 111.74 59.57 111.74 39.54 115.95 39.54 115.95 56.16 124.15 56.16 123.37 59.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.78 59.57 131.78 39.54 144.46 39.54 143.86 42.83 135.95 42.83 135.95 47.46 142.55 47.46 142.55 50.76 135.99 50.76 135.99 56.09 144.75 56.09 144.75 59.57 131.78 59.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.72,59.79c-3.4,0-5.75-1-7.57-3a9.86,9.86,0,0,1-2.5-7.18c0-4,1.34-6.74,4-8.67a9.93,9.93,0,0,1,6-1.74,11.62,11.62,0,0,1,7,2.22L166.49,44a8,8,0,0,0-4.77-1.56c-4.7,0-5.41,3.63-5.41,7.45s1.27,6.92,5.59,6.92a7.13,7.13,0,0,0,2.69-.56V51.72H161l-.6-3.3h8.5v9.63a14.87,14.87,0,0,1-7.19,1.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "177.49 59.57 177.49 39.54 190.17 39.54 189.57 42.83 181.67 42.83 181.67 47.46 188.27 47.46 188.27 50.76 181.71 50.76 181.71 56.09 190.47 56.09 190.47 59.57 177.49 59.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.19,12.73c-2.76,0-3.94,2.07-3.94,6.89,0,5.76,1.46,7.44,4.06,7.44s4-2.08,4-7c0-5.6-1.58-7.28-4.1-7.28m0,17.54c-5.4,0-8.79-4-8.79-10.38S72.87,9.48,78.15,9.48c5.68,0,8.91,4.19,8.91,10.45s-3.43,10.34-8.83,10.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.43,13.71a3.25,3.25,0,0,0-1.23-.28,3.94,3.94,0,0,0-3.75,2.94V29.76H91.12v-14a15.74,15.74,0,0,0-.71-5.32l4-1a7,7,0,0,1,.75,3.13c1.58-2.15,3.16-3.17,5.09-3.17a3.37,3.37,0,0,1,1.54.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.62,30.27c-3.86,0-5.2-2.27-5.2-5.09V12.92h-2.21V10h2.21a38.31,38.31,0,0,1,.2-4.89L111.07,4a53.57,53.57,0,0,0-.35,5.95h4.77l-1.14,3h-3.67V24c0,2.47.55,3.18,2.44,3.18a5,5,0,0,0,1.85-.4l.56,2.59a9.4,9.4,0,0,1-3.91.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.58,29.76V16.29c0-2.46-.87-3.17-2.52-3.17a7.44,7.44,0,0,0-4.82,2.43V29.76h-4.37V6.19a20.07,20.07,0,0,0-.4-4.31l4.38-.94a20.94,20.94,0,0,1,.39,4.66V9.83c0,1.25-.07,2.23-.07,2.23a9,9,0,0,1,6.11-2.58,5.4,5.4,0,0,1,4.85,2.43,7.52,7.52,0,0,1,.67,3.87v14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.23,12.73c-2.45,0-3.79,1.92-3.79,5.13h7.38c0-3.21-1.42-5.13-3.59-5.13M144.4,21v.31c0,2.74,1,5.64,4.93,5.64a7.39,7.39,0,0,0,5-2l1.7,2.63a10.84,10.84,0,0,1-7.18,2.62c-5.64,0-9.19-4-9.19-10.38,0-3.48.75-5.79,2.49-7.75a7.6,7.6,0,0,1,6.11-2.66,7.72,7.72,0,0,1,5.48,2c1.73,1.56,2.6,4,2.6,8.61V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.3,13.71a3.24,3.24,0,0,0-1.22-.28,3.92,3.92,0,0,0-3.75,2.94V29.76H161v-14a15.49,15.49,0,0,0-.71-5.32l4-1a7,7,0,0,1,.74,3.13c1.58-2.15,3.16-3.17,5.09-3.17a3.34,3.34,0,0,1,1.54.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.17,29.76V16.61c0-2.71-.63-3.45-2.29-3.45a7.25,7.25,0,0,0-4.37,2.23V29.76h-4.26V15.19a11.65,11.65,0,0,0-.75-4.69l3.94-1.1a5.79,5.79,0,0,1,.71,2.82c2.13-1.8,4-2.74,6.11-2.74,3.08,0,5.21,1.84,5.21,5.48v14.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.62 29.76 62 29.76 61.89 29.6 47.73 10.19 47.73 29.76 43.17 29.76 43.17 1.63 46.98 1.63 61.06 20.83 61.06 1.63 65.62 1.63 65.62 29.76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthern);
export default __webpack_public_path__ + "static/media/NORTHERN.8b595445550413e552254e7e51671546.svg";
export { ForwardRef as ReactComponent };